import { Box, Typography } from "@mui/material";
import SvgToIcon from "../../icons/SvgToIcon";
import { icons } from "../../scenes/stack/environment/icons/iconExport";
import LetterAvatar from "./LetterAvatar";

const AssigneeLabel = ({ assignee, hideLabel = false }) => {
  const renderAssigneeAvatar = () => {
    if (!assignee) {
      return (
        <SvgToIcon
          IconLogo={icons.AssigneeIcon}
          style={{
            width: "16px",
            height: "16px",
          }}
        />
      );
    }

    return <LetterAvatar name={assignee?.display_name || assignee?.email} />;
  };
  return (
    <Box display="flex" alignItems="center" justifyContent="flex-start" gap={1}>
      {renderAssigneeAvatar()}
      {!hideLabel && (
        <Typography variant="caption" noWrap>
          {assignee ? assignee.display_name || assignee.email : "No Assignee"}
        </Typography>
      )}
    </Box>
  );
};

export default AssigneeLabel;
